<template>
  <div class="form-group">
    <label :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: black}" class="title-bold" for="cep">
      {{questionText}} <span v-if="mandatoryQuestion === false">(Opcional)</span>
    </label>
    <input
      type="text"
      :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
      class="form-control"
      id="cep"
      placeholder="00000-000"
      v-model="cep"
      @focusin="cleanMockupCep"
      @keyup="enterCep"
      v-on:blur="setMockupCep"
      v-mask="['#####-###', '#####-###']"
    />

    <div v-show="showEnd">
      <input
        v-if="completeForm"
        v-focus
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        ref="logradouro"
        class="form-control endereco"
        v-bind:class="[logradouro.length === 0 ? 'endereco-empty' : '', errorClass]"
        :placeholder="$t('form_address_street')"
        v-model="logradouro"
        type="text"
        v-on:keyup="allKeys"
      />
      <input
        v-if="completeForm"
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        v-focus
        ref="numero"
        class="form-control endereco"
        v-bind:class="[numero.length === 0 ? 'endereco-empty' : '', errorClass]"
        :placeholder="$t('form_address_number')"
        v-model="numero"
        type="text"
        v-mask="'####'"
        v-on:keyup="allKeys"
      />
      <input
        v-focus
        v-if="completeForm"
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        ref="complemento"
        class="form-control endereco"
        v-bind:class="[complemento.length === 0 ? 'endereco-empty' : '', errorClass]"
        :placeholder="$t('form_address_complement')"
        v-model="complemento"
        type="text"
        v-on:keyup="allKeys"
      />
      <input
        v-focus
        v-if="completeForm"
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        ref="bairro"
        class="form-control endereco"
        v-bind:class="[bairro.length === 0 ? 'endereco-empty' : '', errorClass]"
        :placeholder="$t('form_address_neighborhood')"
        v-model="bairro"
        type="text"
        v-on:keyup="allKeys"
      />
      <input
        v-focus
        disabled
        ref="municipio"
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        class="form-control endereco"
        v-bind:class="[municipio.length === 0 ? 'endereco-empty' : '', errorClass]"
        :placeholder="$t('form_address_city')"
        v-model="municipio"
        type="text"
        v-on:keyup="allKeys"
      />
      <input
        v-focus
        disabled
        ref="uf"
        :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
        class="form-control endereco"
        v-bind:class="[uf.length === 0 ? 'endereco-empty' : '', errorClass]"
        placeholder="UF"
        v-model="uf"
        type="text"
        v-on:keyup="allKeys"
      />
    </div>
  </div>
</template>

<script>
import { utils } from "../../services/Survey.js";
const U = new utils();

import { mask } from "vue-the-mask";

export default {
  name: "Survey-Adress",
  props: {
    questionText: { type: String },
    questionId: { type: Number },
    config: { type: String},
    mandatoryQuestion: { type: Boolean }
  },
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    showEnd: false,
    cep: "00000000",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    municipio: "",
    uf: "",
    completeForm: false,
    processingApi: false
  }),
  directives: {
    mask,
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted() {
    this.checkConfigToCompleteForm()
    if (this.$store.getters.answerValue(this.questionId)) {
      var Answer = JSON.parse(this.$store.getters.answerValue(this.questionId));

      if (Answer.cep) this.cep = Answer.cep;

      if (Answer.logradouro) this.logradouro = Answer.logradouro;

      if (Answer.numero) this.numero = Answer.numero;

      if (Answer.complemento) this.complemento = Answer.complemento;

      if (Answer.bairro) this.bairro = Answer.bairro;

      if (Answer.municipio) this.municipio = Answer.municipio;

      if (Answer.uf) this.uf = Answer.uf;

      if (this.cep !== "00000-000") this.showEnd = true
    } else {
      this.mountAnswer()
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId) //set default answer 00000-000
    }

    this.focusInput();
  },
  updated() {
    this.focusInput();
  },
  computed: {
    template() {
      return this.$store.state.template;
    }
  },
  methods: {
    checkConfigToCompleteForm() {
      if (this.config && this.config.includes('completeAddressForm')) {
        this.completeForm = true
      }
    },
    focusInput() {
      this.$refs.fc.$el.focus();
    },
    mountAnswer() {
      if (this.completeForm) {
        this.qtAnwser = "{";
        this.qtAnwser += '"cep":"' + this.cep + '",';
        this.qtAnwser += '"logradouro":"' + this.logradouro + '",';

        if (!this.numero) this.numero = "";

        this.qtAnwser += '"numero":"' + this.numero + '",';

        if (!this.complemento) this.complemento = "";
        this.qtAnwser += '"complemento":"' + this.complemento + '",';
        this.qtAnwser += '"bairro":"' + this.bairro + '",';
        this.qtAnwser += '"municipio":"' + this.municipio + '",';
        this.qtAnwser += '"uf":"' + this.uf + '"';
        this.qtAnwser += "}";
      } else {
        this.qtAnwser = "{"
        this.qtAnwser += '"cep":"' + this.cep + '",'
        this.qtAnwser += '"logradouro":"' + this.logradouro + '",'
        this.qtAnwser += '"bairro":"' + this.bairro + '",';
        this.qtAnwser += '"municipio":"' + this.municipio + '",';
        this.qtAnwser += '"uf":"' + this.uf + '"';
        this.qtAnwser += "}";
      }
    },
    allKeys() {
      //montar a resposta
      this.mountAnswer();
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    cleanMockupCep() {
      if (this.cep === "00000-000") {
        this.cep = ""
      }
    },
    setMockupCep() {
      if (this.cep === "") {
        this.cep = "00000-000"
        this.ErrorOccured("Endereço informado incorreto.");
      }
    },
    enterCep(event) {
      if (event.key === 'Enter' || event.key === 'Control' ||  event.key === 'Meta') {
        event.preventDefault
        this.processingApi = false
      } else if (this.cep.length === 9) {
        if (this.processingApi) {
          return false
        }
        this.processingApi = true
        if (this.cep === "00000-000") {
          this.mountAnswer()
          this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
          this.processingApi = false
        }
        U.getCep(this.cep.replace("-","")).then(
          datacep => {
            if(datacep.erro){
              this.cep = "";
              this.qtAnwser = datacep.erro;
              this.processingApi = false
              this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
            } else {
              this.showEnd = true
              if (datacep.complemento)
                this.logradouro =
                  datacep.logradouro + "(" + datacep.complemento + ")";
              else this.logradouro = datacep.logradouro;

              (this.bairro = datacep.bairro), (this.municipio = datacep.localidade);
              this.uf = datacep.uf;

              this.mountAnswer()
              if (!this.completeForm) {
                this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
              }
              this.processingApi = false
          }
          },
          err => {
            alert(err);
            this.processingApi = false
          }
        );
      }
    }
  }
};
</script>
<style scoped>
.title-bold{
  font-family:'OxaniumBold';
}
</style>
